import { SelectedTasksStore } from '@bringg-frontend/monitoring';

import { generateStoreHelpers } from 'bringg-web/components/with-root-store/store-helper-generator';
import RoutesMonitoringStore from './routes-monitoring-store';
import RoutesMonitoringTableViewStore from './routes-monitoring-table-view-store';
import RoutesMonitoringMapViewStore from './routes-monitoring-map-view-store';
import RoutesMonitoringTimelineViewStore from './routes-monitoring-timeline-view-store';
import { routesMonitoringPolling } from '../utils/routes-monitoring-polling';
import { etaCalculatorProvider } from '../../shared/utils/eta-calculator/eta-calculator-provider';
import RouteMonitoringActionsStore from './routes-monitoring-actions-store';
import RoutesMonitoringViewStore from './routes-monitoring-view-store';

class RoutesMonitoringRootStore {
	private static _instance?: RoutesMonitoringRootStore;

	private disposeAC: AbortController;

	// Global stores to the page, please add here only stores that are used in all views
	routesMonitoringStore: RoutesMonitoringStore;
	routesMonitoringViewStore: RoutesMonitoringViewStore;

	// Stores for specific cases
	routesMonitoringTableViewStore: RoutesMonitoringTableViewStore;
	routeMonitoringMapViewStore: RoutesMonitoringMapViewStore;
	routeMonitoringTimelineViewStore: RoutesMonitoringTimelineViewStore;
	routeMonitoringActionsStore: RouteMonitoringActionsStore;
	selectedTasksStore: SelectedTasksStore;

	public static get instance(): RoutesMonitoringRootStore {
		if (!RoutesMonitoringRootStore._instance) {
			RoutesMonitoringRootStore._instance = new RoutesMonitoringRootStore();
			RoutesMonitoringRootStore._instance.init();
		}

		return RoutesMonitoringRootStore._instance;
	}

	init() {
		this.disposeAC = new AbortController();
		this.routesMonitoringViewStore = new RoutesMonitoringViewStore(this.disposeAC.signal);
		this.routesMonitoringStore = new RoutesMonitoringStore(this.disposeAC.signal);
		this.routeMonitoringTimelineViewStore = new RoutesMonitoringTimelineViewStore(this.disposeAC.signal);
		this.routesMonitoringTableViewStore = new RoutesMonitoringTableViewStore();
		this.routeMonitoringMapViewStore = new RoutesMonitoringMapViewStore(this.disposeAC.signal);
		this.routeMonitoringActionsStore = new RouteMonitoringActionsStore();
		this.selectedTasksStore = new SelectedTasksStore();
	}

	static clear() {
		if (RoutesMonitoringRootStore._instance) {
			RoutesMonitoringRootStore._instance.disposeAC.abort();
			RoutesMonitoringRootStore._instance = undefined;
		}
		routesMonitoringPolling.stop();
		etaCalculatorProvider.clear();
	}
}

export type RoutesMonitoringRoot = RoutesMonitoringRootStore;

export const routesMonitoringRootStore = {
	getStore: () => RoutesMonitoringRootStore.instance,
	clearStore: () => RoutesMonitoringRootStore.clear()
};

export const { useStoreContext: useRoutesMonitoringRootStore, withRootStore: withRoutesMonitoringRootStore } =
	generateStoreHelpers(routesMonitoringRootStore);
